import buildQuery from 'odata-query';

import { MethodsTypes, IRequestConfig } from 'models/Axios';
import {
  IProductsData,
  IProducts,
  ICategory,
  ISubCategory,
} from 'models/Product';
import store from 'store';
import Axios from 'axios';
import toast from 'components/Toast/dispatch';
import { ITickets } from 'models/Ticket';
import iconStockAvailable from 'img/icon-stock-available.svg';
import iconStockNotAvailable from 'img/icon-stock-not-available.svg';
import TicketServices from './ticket.service';
import DomainSettingService from 'services/domainSetting.service';
import Services from './index.service';
import { eventName, produtosAction } from 'components/ApplicationInsights/eventNames';
import { SelectCustomerIdIsArray } from 'utils/SelectCustomerIdIsArray';

const _ticketService = new TicketServices();
const _domainSettingService = new DomainSettingService();

export default class ProductServices extends Services<
  IProductsData,
  IProducts
> {
  /**
   * Function to get a limited qtd of items
   * @currentPage Range to skip, you need only pass currentPage (ex: currentPage = 1)
   * @pageSize Range to take, you need only pass pageSize (ex: pageSize = 15)
   */
  get = (
    currentPage?: number,
    pageSize?: number,
    orderby?: string,
    filter?: {}
  ) => {
    const skip = currentPage || 0;
    const top = pageSize || 20;
    const order = orderby ? `${orderby}` : undefined;

    // const customer = store.getState().customer;

    const filterQuery = buildQuery({ filter: { ...filter } });

    const config: IRequestConfig<IProducts> = {
      url: `/product${filterQuery}`,
      params: {
        $top: `${top}`,
        $skip: `${skip * top}`,
        $orderby: order,
      },
    };

    return this.httpRequest(config);
  };

  getProducts = (
    productBrand: string,
    substance: string,
    name: string,
    code: string,
    currentPage?: number,
    pageSize?: number,
    orderby?: string,
  ) => {
    const skip = currentPage || 0;
    const take = pageSize || 20;
    const order = orderby ? `${orderby}` : undefined;

    const config: IRequestConfig<IProducts> = {
      baseUrl: process.env.REACT_APP_API_MAFRAQ_URL,
      url: `/product/product-price-quote`,
      method: MethodsTypes.get,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
      params: {
        productBrand,
        name,
        substance,
        code,
        enterpriseCode: 1,
        take: `${take}`,
        skip: `${skip * take}`,
        $orderby: order,
      },
    };

    return this.httpRequest(config);
  };

  getCustomFilter = (
    currentPage?: number,
    pageSize?: number,
    orderby?: string,
    filter?: string
  ) => {
    const skip = currentPage || 0;
    const top = pageSize || 20;
    const order = orderby ? `${orderby}` : undefined;
    const filterQuery = filter;

    const config: IRequestConfig<IProducts> = {
      url: `/product${filterQuery}`,
      params: {
        $top: `${top}`,
        $skip: `${skip * top}`,
        $orderby: order,
      },
    };

    return this.httpRequest(config);
  };

  public async CheckAvailability(product: IProducts) {
    if (SelectCustomerIdIsArray()) return;

    const { customer } = store.getState();
    const { user } = store.getState();

    const response = await _domainSettingService.get(undefined, undefined, 'value asc', {
      and: [{ identifier: { eq: 'ProductsOnRequest' } }, { enabled: { eq: true } }]
    });

    const { data } = response;
    const enterpriseProductsOnRequest: string[] = data[0].value.split(',');
    const findEnterpriseCodeProduct = enterpriseProductsOnRequest.includes(String(product.enterpriseCode));

    const _filter: any = {};
    _filter.id = product.id;
    _filter.customerId = customer?.id ?? user?.selectedCustomerId;
    // _filter.subsidiary = product.subsidiary;
    // _filter.enterpriseCode = product.enterpriseCode;
    const filterQuery = Object.entries(_filter)
      .map((e) => e.join('='))
      .join('&');

    const config: IRequestConfig<any> = {
      url: `${this.base_url}/product/availability${filterQuery ? `?${filterQuery}` : ''
        }`,
      method: MethodsTypes.get,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
    };

    return await Axios(config)
      .then((result) => {
        if (result?.data !== undefined) {

          if (result.data?.ok || findEnterpriseCodeProduct) {

            const title = result?.data?.locked || findEnterpriseCodeProduct
              ? `Item Vendido Sob Consulta`
              : `Estoque ${result?.data?.isAvaible === true ? 'Disponível' : 'Indisponível'
              }`;

            const message =
              result?.data?.isAvaible === true
                ? 'Gostaria que nosso time comercial entre em contato com você?'
                : 'Gostaria que nosso time comercial entre em contato com você para entender melhor sua necessidade?';
            const icon =
              result?.data?.isAvaible === true
                ? iconStockAvailable
                : iconStockNotAvailable;

            toast.yesNoCustom(
              title,
              message,
              () => this.CreateTicket(result.data.ticket),
              icon,
              98,
              'Sim',
              'Não',
              eventName.ABRIR_PROTOCOLO,
              result?.data?.isAvaible ? produtosAction.ESTOQUEDISPONIVELSIM : produtosAction.ESTOQUEDISPONIVELNAO
            );
          }
          else {

            toast.yesNoCustom(
              "Estoque Indisponível",
              "Gostaria que nosso time comercial entre em contato com você para entender melhor sua necessidade?",
              () => this.CreateTicket(result.data.ticket),
              iconStockNotAvailable,
              98,
              'Sim',
              'Não',
              eventName.ABRIR_PROTOCOLO,
              produtosAction.ESTOQUEDISPONIVELNAO
            );

          }
        }
      })
      .catch((ex) => {
        if (ex?.response?.data?.data !== undefined)
          toast.error(ex.response.data.data);
      });
  }

  setProdutcOutPortfolio = (buyerIdentifier: string, hospitalProductCode: string, quoteId: string, sequenceNumber: number) => {
    const config: IRequestConfig<string> = {
      url: `${this.mafraq_url}/Product/SetProdutcOutPortfolio?buyerIdentifier=${buyerIdentifier}&hospitalProductCode=${hospitalProductCode}&quoteId=${quoteId}&sequenceNumber=${sequenceNumber}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
      method: MethodsTypes.post
    };

    return Axios(config);
  };

  getDownloadTechnicalSheet = async (productId: string) => {
    return Axios({
      method: 'get',
      url: `${this.mafraq_url}/Product/DownloadTechnicalSheet/${productId}`,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/pdf',
        Authorization: `Bearer ${this.access_token()}`,
      },
    });
  };

  private async CreateTicket(ticket: ITickets) {
    if (ticket === undefined)
      toast.error('Não foi possível recuperar o ticket.');
    else {
      await _ticketService
        .create(ticket)
        .then((response) => {
          toast.success(
            `O protocolo ${response.data.data.protocolNumber} foi registrado com sucesso!`
          );
        })
        .catch(() => {
          toast.error('Ocorreu um erro durante a requisição');
        });
    }
  }

  getCategory = () => {
    const _mockMateriaisSub = Array<ISubCategory>();
    _mockMateriaisSub.push({
      id: 1,
      name: 'Cardiaca',
      _mockKey: 'Excepteur Pariatur',
    });
    _mockMateriaisSub.push({
      id: 2,
      name: 'Cirurgica',
      _mockKey: 'Tempor Commodo',
    });
    _mockMateriaisSub.push({
      id: 3,
      name: 'Urinarios',
      _mockKey: 'Anim Reprehenderit',
    });
    _mockMateriaisSub.push({
      id: 4,
      name: 'Ortopedica',
      _mockKey: 'Irure Esse',
    });
    _mockMateriaisSub.push({
      id: 5,
      name: 'Respiratoria',
      _mockKey: 'Occaecat Reprehenderit',
    });

    const _mockSubMedicamentos = Array<ISubCategory>();
    _mockSubMedicamentos.push({
      id: 1,
      name: 'Analgésicos',
      _mockKey: 'Excepteur Pariatur',
    });
    _mockSubMedicamentos.push({
      id: 2,
      name: 'Antibióticos',
      _mockKey: 'Tempor Commodo',
    });
    _mockSubMedicamentos.push({
      id: 3,
      name: 'Controle Especial',
      _mockKey: 'Anim Reprehenderit',
    });
    _mockSubMedicamentos.push({
      id: 4,
      name: 'Diversos',
      _mockKey: 'Irure Esse',
    });

    const _mockSubHospitalar = Array<ISubCategory>();
    _mockSubHospitalar.push({
      id: 1,
      name: 'Terapia Cirúrgica',
      _mockKey: 'Excepteur Pariatur',
    });
    _mockSubHospitalar.push({
      id: 2,
      name: 'Higiene e Proteção',
      _mockKey: 'Tempor Commodo',
    });
    _mockSubHospitalar.push({
      id: 3,
      name: 'Assistência Respiratória',
      _mockKey: 'Anim Reprehenderit',
    });
    _mockSubHospitalar.push({
      id: 4,
      name: 'Terapia Infusional',
      _mockKey: 'Irure Esse',
    });

    const _mockSubCuidado = Array<ISubCategory>();
    _mockSubCuidado.push({
      id: 1,
      name: 'Assitência Respiratória',
      _mockKey: 'Excepteur Pariatur',
    });
    _mockSubCuidado.push({
      id: 2,
      name: 'Primeiros Socorros',
      _mockKey: 'Tempor Commodo',
    });
    _mockSubCuidado.push({
      id: 3,
      name: 'Cuidados Infantis',
      _mockKey: 'Anim Reprehenderit',
    });
    _mockSubCuidado.push({
      id: 4,
      name: 'Terapia Infusional',
      _mockKey: 'Irure Esse',
    });

    const _mockSubVacina = Array<ISubCategory>();
    _mockSubVacina.push({
      id: 1,
      name: 'Vacinas',
      _mockKey: 'Excepteur Pariatur',
    });

    const _mock = Array<ICategory>();
    _mock.push({
      id: 1,
      name: 'Materiais',
      _mockKey: 'Excepteur Pariatur',
      subOptions: _mockMateriaisSub,
    });
    _mock.push({
      id: 2,
      name: 'Medicamentos',
      _mockKey: 'Tempor Commodo',
      subOptions: _mockSubMedicamentos,
    });
    _mock.push({
      id: 3,
      name: 'Hospitalar',
      _mockKey: 'Anim Reprehenderit',
      subOptions: _mockSubHospitalar,
    });
    _mock.push({
      id: 4,
      name: 'Cuidado & Bem estar',
      _mockKey: 'Irure Esse',
      subOptions: _mockSubCuidado,
    });
    _mock.push({
      id: 5,
      name: 'Vacinas - Tecnocold',
      _mockKey: 'Occaecat Reprehenderit',
      subOptions: _mockSubVacina,
    });
    return _mock;
  };

  getProductsWithBlockedItems = (
    productBrand: string,
    substance: string,
    name: string,
    code: string,
    currentPage?: number,
    pageSize?: number,
    orderby?: string,
  ) => {
    const skip = currentPage || 0;
    const take = pageSize || 20;
    const order = orderby ? `${orderby}` : undefined;

    const config: IRequestConfig<IProducts> = {
      baseUrl: process.env.REACT_APP_API_MAFRAQ_URL,
      url: `/product/product-price-quote-with-blocked-items`,
      method: MethodsTypes.get,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
      params: {
        productBrand,
        name,
        substance,
        code,
        enterpriseCode: 1,
        take: `${take}`,
        skip: `${skip * take}`,
        $orderby: order,
      },
    };

    return this.httpRequest(config);
  };

}
